module.exports = __webpack_public_path__ + "img/domain-dashboard.dda615ba.svg";